import moment from "moment"

export function fromNow(datetime) {
  return moment(datetime.seconds * 1000).fromNow();
}